import { GROUP_NOUNS } from 'modules/featureFlags/constants';
import { Actions, Nouns } from 'modules/featureFlags/types';
import styled from 'styled-components';
import { Body2, Caption } from 'ui/theme';

const Row = styled(Body2)`
  display: flex;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.values.half};

  & + & {
    padding-top: 20px;
    margin-top: 20px;
    border-top: ${({ theme }) =>
      `${theme.spacing.values.single} solid ${theme.colors.neutrals.grey5}`};
  }
`;

const StyledCaption = styled(Caption)`
  color: ${({ theme }) => theme.colors.textColors.textSecondary};
`;

type ConfirmationCardRowProps = {
  added: number;
  removed: number;
  total: number;
  noun: Nouns;
  variant: Actions;
};

export const ConfirmationCardRow = ({
  added,
  removed,
  total,
  noun,
  variant,
}: ConfirmationCardRowProps) => {
  const { singular, plural } = GROUP_NOUNS[noun];
  const totalNoun = total === 1 ? singular : plural;
  const lowerVariant = variant.toLowerCase();
  return (
    <Row>
      <span>
        <b>
          {total} {totalNoun}
        </b>{' '}
        will be {lowerVariant}
      </span>
      <StyledCaption>
        {added} added, {removed} removed
      </StyledCaption>
    </Row>
  );
};
